module.exports = __webpack_public_path__ + "static/media/check_u.7f64666a.png";